module.exports = __webpack_public_path__ + "assets/images/skincolor-04.f555f0097ca32952bceea1c379c4241f.svg";